export default "__VITE_ASSET__2c5606e0__"